import HeadingText from "../ActionCommonComponent/HeadingText"
import { useNavigate } from "react-router-dom"
import { Button } from "../../../../common/Buttons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"

const NodeActions = ({ data }) => {
  const { audit_trail_id, version_id } = data
  const navigate = useNavigate()
  const canOpenPreview = Boolean(audit_trail_id)
  return (
    <>
      <HeadingText heading="Associated Version" text={version_id} />

      <HeadingText heading="Activity" text={data.action}>
        <span style={{ marginLeft: "8px" }}>
          <Button
          variant="outline-blue"
            size="sm"
            iconOnly={true}
            icon={<FontAwesomeIcon icon={faArrowRight} />}
            // disabled={!canOpenPreview}
            disabled={true}
            onClick={() => {
              if(data?.version_content?.item_type_cat_update){
                navigate("/audit-trail/item_type_cat_update_preview/" + audit_trail_id)
              }
              else if (canOpenPreview) {
                navigate("/audit-trail/preview/" + audit_trail_id)
              }
            }}
          >
          </Button>
        </span>
      </HeadingText>
      <HeadingText heading="Comment" text={data.comment}/>
    </>
  )
}

export default NodeActions